import { GenericRadioOptions } from "@portal/BaseComponents/Radio/types";
import { BaseEntity } from "@portal/types/entities/base-entity";
import { DocumentTypes } from "@portal/types/entities/documents";

export const entityLevelOptions: GenericRadioOptions<BaseEntity> = [
  {
    label: "Customer",
    value: "CUSTOMER",
  },

  {
    label: "Invoice",
    value: "INVOICE",
  },
];

export const mapDocumentTypesOptionPredicate = (types: DocumentTypes) => {
  return { label: types.name, value: types.id };
};

export const filterDocumentTypesOptionPredicate = (types: DocumentTypes) => {
  return Boolean(types.enabled);
};
